import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ErrorHandler, NgModule } from '@angular/core';
import {
  HttpClientModule,
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientJsonpModule,
} from '@angular/common/http';
import {
  NgbNavModule,
  NgbAccordionModule,
  NgbTooltipModule,
  NgbModule,
} from '@ng-bootstrap/ng-bootstrap';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { SharedModule } from './cyptolanding/shared/shared.module';
import { ExtrapagesModule } from './extrapages/extrapages.module';
import { LayoutsModule } from './layouts/layouts.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CyptolandingComponent } from './cyptolanding/cyptolanding.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { JwtInterceptor } from './core/helpers/jwt.interceptor';
import { DataTablesModule } from 'angular-datatables';
import { DatePipe } from '@angular/common';
import { ToastNoAnimationModule } from 'ngx-toastr';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { HttpErrorInterceptorService } from './core/services/interceptors/httpError-interceptor.service';
import { GoogleMapsModule } from '@angular/google-maps';
import { FormsModule } from '@angular/forms';
import { TreeModule } from 'primeng/tree';
import { ButtonModule } from 'primeng/button';
import { GlobalErrorHandler } from './core/handlers/global-error.handler';

export function createTranslateLoader(http: HttpClient): any {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

@NgModule({
  declarations: [AppComponent, CyptolandingComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    HttpClientJsonpModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    LayoutsModule,
    AppRoutingModule,
    ExtrapagesModule,
    CarouselModule,
    NgbAccordionModule,
    NgbNavModule,
    NgbTooltipModule,
    SharedModule,
    DataTablesModule,
    ToastNoAnimationModule.forRoot(),
    NgxDropzoneModule,
    NgbModule,
    GoogleMapsModule,
    FormsModule,
    TreeModule,
    ButtonModule,
  ],
  bootstrap: [AppComponent],
  // providers: [
  //   { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptorService, multi: true },
  //   { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
  //   // { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
  //   { provide: HTTP_INTERCEPTORS, useClass: FakeBackendInterceptor, multi: true },
  //   DatePipe
  // ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    // { provide: HTTP_INTERCEPTORS, useClass: loaderInterceptor, multi: true }, // ✅ Agregar
    // { provide: HTTP_INTERCEPTORS, useClass: FakeBackendInterceptor, multi: true },
    DatePipe,
  ],
})
export class AppModule {}
